import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "atomizer-box" };
const _hoisted_2 = { class: "atomizer-box__cover" };
const _hoisted_3 = { class: "atomizer-box__main" };
const _hoisted_4 = { class: "atomizer-box__block" };
const _hoisted_5 = { class: "atomizer-box__block" };
const _hoisted_6 = {
    key: 0,
    class: "atomizer-price"
};
const _hoisted_7 = { class: "atomizer-price__qty" };
const _hoisted_8 = { class: "atomizer-price__value" };
const _hoisted_9 = { class: "atomizer-price__button" };
import { computed, ref } from "vue";
import ModalDialog from "../../../../components/modal/ModalDialog.vue";
import Picture from "../../../../components/Picture.vue";
import QuantityBox from "../products/QuantityBox.vue";
import { handleAddToCartButtonClick } from "../../../../components/product/add_to_cart";
import CartEventBus from "../../CartEventBus";
import FilterSelector from "../../../product/components/FilterSelector.vue";
import Price from "../../../../components/Price.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AtomizerModal',
    props: {
        atomizers: { type: Array, required: true },
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const modal = ref();
        const selectedVolume = ref();
        const selectedColor = ref();
        const quantity = ref(1);
        // 1. Уникальные объемы (для первого фильтра)
        const volumeFilterItems = computed(() => {
            return [...new Set(props.atomizers.map(a => a.volume))]
                .sort((a, b) => a - b)
                .map(v => ({ id: v, name: `${v} мл` }));
        });
        // 2. Уникальные цвета для выбранного объема
        const colorFilterItems = computed(() => {
            if (!selectedVolume.value) {
                return [];
            }
            const available = props.atomizers
                .filter(a => a.volume === selectedVolume.value?.id)
                .map(a => ({
                id: a.color,
                name: a.color,
                color_code: a.color_code,
            }));
            return available.sort((a, b) => a.name.localeCompare(b.name));
        });
        // 3. Итоговый атомайзер ищем по комбинации Объем + Цвет
        const selectedAtomizer = computed(() => {
            return props.atomizers.find(a => a.volume === selectedVolume.value?.id &&
                a.color === selectedColor.value?.id);
        });
        const sum = computed(() => {
            return selectedAtomizer.value ? selectedAtomizer.value.price * quantity.value : 0;
        });
        function show() {
            modal.value?.open();
        }
        function close() {
            modal.value?.close();
        }
        __expose({ show });
        async function addToCart() {
            const id = selectedAtomizer.value?.id;
            if (!id) {
                return;
            }
            await handleAddToCartButtonClick({ id, cnt: quantity.value, silent: true });
            CartEventBus.emit('cart:refresh');
            close();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ModalDialog, {
                id: "modal-atomizer",
                title: "Выбор атомайзера",
                size: "lg",
                ref_key: "modal",
                ref: modal
            }, {
                main: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            (selectedAtomizer.value)
                                ? (_openBlock(), _createBlock(Picture, {
                                    picture: selectedAtomizer.value.image,
                                    key: selectedAtomizer.value.id,
                                    aspect: false,
                                    lazy: false,
                                    width: 200,
                                    height: 200
                                }, null, 8 /* PROPS */, ["picture"]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(FilterSelector, {
                                    title: "Объём",
                                    items: volumeFilterItems.value,
                                    name: "atomizer_volume",
                                    modelValue: selectedVolume.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedVolume).value = $event))
                                }, null, 8 /* PROPS */, ["items", "modelValue"])
                            ]),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(FilterSelector, {
                                    title: "Цвет",
                                    items: colorFilterItems.value,
                                    name: "atomizer_color",
                                    modelValue: selectedColor.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedColor).value = $event))
                                }, null, 8 /* PROPS */, ["items", "modelValue"])
                            ])
                        ])
                    ])
                ]),
                bottom: _withCtx(() => [
                    (selectedAtomizer.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createVNode(QuantityBox, {
                                    modelValue: quantity.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((quantity).value = $event))
                                }, null, 8 /* PROPS */, ["modelValue"])
                            ]),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_8, [
                                _createVNode(Price, { amount: sum.value }, null, 8 /* PROPS */, ["amount"])
                            ]),
                            _cache[7] || (_cache[7] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("button", {
                                    onClick: _withModifiers(addToCart, ["prevent"]),
                                    class: "btn btn--1 btn--m btn--black"
                                }, [...(_cache[5] || (_cache[5] = [
                                        _createElementVNode("span", { class: "btn__label" }, "Добавить", -1 /* CACHED */)
                                    ]))])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }, 512 /* NEED_PATCH */));
        };
    }
});
